import gql from 'graphql-tag';

export const AD_SETS_WITH_INSIGHTS_QUERY = gql`
  query AdSetsWithInsightsQuery(
    $filter: AdSetsFilterInput!
    $insightsFilter: AdInsightsFilterInput!
    $aggregationPeriod: String!
    $attributionWindow: AttributionWindowEnum
  ) {
    adSets(filter: $filter) {
      id
      facebookAdSetId
      name
      facebookState
      adsManagerUrl
      dailyBudget
      actionsBid
      dailySpendCapMode
      availableDailySpendCapModes
      source
      adSetSpentToday {
        spentToday
        discountSpentToday
      }
      article {
        id
        title
        url
        campaignId
        deprecated
        starred
      }
      campaign {
        name
        bidStrategy
        facebookCboEnabled
        joggerProfile
      }
      keyweeFacebookCampaign {
        facebookCboEnabled
      }
      audience {
        description
        location
        age
        customAudiences
        interests
        behaviors
      }
      insights(filter: $insightsFilter, aggregationPeriod: $aggregationPeriod, attributionWindow: $attributionWindow) {
        spendBeforeDiscount
        spendAfterDiscount
        clicks
        impressions
        ctr
        cpm
        cpc
        maxCpa
        cpcRatio
        revenue
        revenueRoi
        profit
        pixelPageViews
        pixelSessions
        pixelAveragePageViewsPerSession
        pixelCostPerPageView
        conversions {
          id
          totalActions
          totalValue
          costPerAction
          roas
          aov
        }
      }
    }
  }
`;
